import React from "react";
import { Answers } from "gui/answers/answers";
import { Embed } from "gui/embed/embed";
import { Entries } from "gui/entries/entries";
import { Feature } from "gui/feature/feature";
import { Hero } from "gui/hero/hero";
import { Logos } from "gui/logos/logos";
import { PageTitle } from "gui/pagetitle/pagetitle";
import { Popular } from "gui/popular/popular";
import { Projects } from "gui/projects/projects";
import { Quotes } from "gui/quotes/quotes";
import { SanityDocumentPage } from "lib/sanity/types";
import { SanitySection } from "lib/sanity/types";
import { Spacer } from "gui/spacer/spacer";
import { Text } from "gui/text/text";

export const SanitySections: React.FC<{
  page: SanityDocumentPage;
}> = (props) => {
  return (
    <>
      {props.page.sections.map((item: SanitySection, i) => (
        <React.Fragment key={item._key}>
          <SectionContent item={item} />
          <SectionSpacer items={props.page.sections} index={i} />
        </React.Fragment>
      ))}
    </>
  );
};

const SectionContent: React.FC<{
  item: SanitySection;
}> = (props) => {
  const { item } = props;

  // Find the component for this section based on the _type field
  // that we get from Sanity. All new section types require a
  // dedicated component, and an entry in this switch statement.
  switch (item._type) {
    case "answers":
      return <Answers item={item} />;
    case "embed":
      return <Embed {...item} watermark={false} transparent revealOnScroll />;
    case "entries":
      return <Entries {...item} entries={item.entries!.results} />;
    case "feature":
      return <Feature item={item} />;
    case "hero":
      return <Hero item={item} />;
    case "logos":
      return <Logos item={item} />;
    case "popular":
      return <Popular item={item} />;
    case "projects":
      return <Projects item={item} />;
    case "quotes":
      return <Quotes item={item} />;
    case "rich":
      return <Text item={item} />;
    case "title":
      return <PageTitle {...item} revealOnLoad />;

    default: {
      // We may reach this case if the `item._type` is not added to any of
      // our SanitySection types. That is why we have this default case.
      // Thus ts-ignore the lookup of `item._type`.
      // @ts-ignore
      const type = item._type;
      throw Error(`unknown Sanity content type=${type}`);
    }
  }
};

const SectionSpacer: React.FC<{
  items: SanitySection[];
  index: number;
}> = (props) => {
  const type = props.items[props.index]._type;

  if (type === "hero") {
    return null;
  }

  if (type === "title") {
    return <Spacer />;
  }

  return <Spacer size="lg" />;
};
